import React from 'react'

import cn from 'classnames'

import styles from './BadgeCount.module.scss'

interface BadgeCountProps {
  count: number
  className?: string
}

export const BadgeCount: React.FC<BadgeCountProps> = ({ count, className }) => {
  if (!count || count <= 0) return null

  const display = count > 99 ? '99+' : String(count)

  return <span className={cn(styles.badge, className)}>{display}</span>
}
